import {get} from 'svelte/store';
import {analytics, modal, popupData} from 'general/store';
import {ANALYTICS, COOKIE_VALUE, POPUP_TYPE, TEMPLATE, VIEW} from 'general/constants';
import {openPopup} from './openPopup';
import {getCookie} from '../getCookie';
import {sendAnalyticsPerDay} from 'general/libs/pushDataLayer';
import {setCookie} from 'general/libs/setCookie';

export let exitPopupTimer: ReturnType<typeof setTimeout>;

/**
 * Open Exit Popup
 * @param {boolean} isOpen immediate opening flag
 */
export const openExitPopup = (isOpen = false): void => {
    const modalState = get(modal);
    const exitSelector: string = modalState.popupSelectors.exitPopup;

    clearTimeout(exitPopupTimer);

    if (modalState.view === VIEW.MAIN && modalState.isVisible) return;

    const data = get(popupData);
    const isTemplate = Boolean(data.value?.[exitSelector]?.template);
    const isAnalyticsAction = Boolean(data.analytics?.[exitSelector]?.action);
    const isShowExit = Boolean(getCookie(COOKIE_VALUE.IS_EXIT_SHOW));

    if (!isShowExit && !isTemplate && isAnalyticsAction) {
        exitPopupTimer = setTimeout(
            () => {
                analytics.set(data.analytics[exitSelector]);
                modal.changePopupType(POPUP_TYPE.EXIT);
                sendAnalyticsPerDay(ANALYTICS.POPUP_SHOWED);
                setCookie(COOKIE_VALUE.IS_EXIT_SHOW, 'true', 1);
                analytics.set(data.analytics[modalState.popupSelectors.welcomePopup]);
            },
            isOpen ? 0 : data.analytics[exitSelector].timer || 0,
        );
    }

    if (
        (isShowExit ||
            !isTemplate ||
            Boolean(
                getCookie(COOKIE_VALUE.SUBSCRIBER) && !data.value?.[exitSelector]?.description?.sms,
            )) &&
        data.value?.[exitSelector]?.template !== TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS
    ) {
        return;
    }

    if (
        (isShowExit || !isTemplate) &&
        data.value?.[exitSelector]?.template === TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS
    ) {
        return;
    }

    const timerTime = isOpen ? 0 : data.value[exitSelector].timer || 0;

    const listener = (e: CustomEvent<boolean>) => {
        const tryOnOpen = e.detail;

        if (tryOnOpen) {
            clearTimeout(exitPopupTimer);
        } else {
            clearTimeout(exitPopupTimer);
            exitPopupTimer = startExitPopupTimer();
        }
    };

    const startExitPopupTimer = () =>
        setTimeout(() => {
            modal.changePopupType(POPUP_TYPE.EXIT);
            openPopup(exitSelector);
            window.removeEventListener('dynamicYield:EPopupOpen', listener as EventListener);
        }, timerTime);

    exitPopupTimer = startExitPopupTimer();

    window.addEventListener('dynamicYield:EPopupOpen', listener as EventListener);

    const unsubscribeListeners = () => {
        window.removeEventListener('dynamicYield:EPopupOpen', listener as EventListener);
        window.removeEventListener('mfPopup:unMount', unsubscribeListeners);
    };
    window.addEventListener('mfPopup:unMount', unsubscribeListeners);
};
